import { IGeoDataResponse } from 'models/geo.model'
import { geoApi } from 'nove8/api'
import { ProcessingKey } from 'nove8/constants/root-constants'
import { useZustandStore } from 'zustandGlobalStore'

export const fetchGeoData = async (): Promise<IGeoDataResponse | null> => {
  useZustandStore.getState().startProcessing(ProcessingKey.FETCH_GEO_DATA)

  try {
    const response = await geoApi.getGeoData()
    const responseData = response.data
    useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_GEO_DATA)
    return responseData
  } catch (error) {
    useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_GEO_DATA)
    return null
  }
}
